<template>
  <div>
    <form role="form">

      <div class="alert alert-info">
        <i class="fas fa-info-circle"></i> {{ translate('invoice.required_fields_1') }} <sup
        class="sup-star">*</sup> {{ translate('invoice.required_fields_2') }}
      </div>

      <section class="style-block-av">
        <div>
          <h3>{{ translate('invoice.participant_data') }}</h3>
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <label for="gender">{{ translate('invoice.gender') }}
                  <sup class="sup-star">*</sup>
                </label>
                <select id="gender"
                        name="gender"
                        class="form-control"
                        :class="{'is-invalid': updateParticipantForm.errors.has('gender')}"
                        v-model="updateParticipantForm.gender">
                  <option value="male">{{ translate('invoice.male') }}</option>
                  <option value="female">{{ translate('invoice.female') }}</option>
                </select>
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('gender')">
                    <strong>{{ updateParticipantForm.errors.get('gender') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="prefix">{{ translate('invoice.prefix') }}</label>
                <input id="prefix" type="text" name="prefix"
                       v-model="updateParticipantForm.prefix"
                       :class="{'is-invalid': updateParticipantForm.errors.has('prefix')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('prefix')">
                    <strong>{{ updateParticipantForm.errors.get('prefix') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="first_name">{{ translate('invoice.first_name') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="first_name" type="text" name="first_name"
                       v-model="updateParticipantForm.first_name"
                       :class="{'is-invalid': updateParticipantForm.errors.has('first_name')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('first_name')">
                    <strong>{{ updateParticipantForm.errors.get('first_name') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="last_name">{{ translate('invoice.last_name') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="last_name" type="text" name="last_name"
                       :class="{'is-invalid': updateParticipantForm.errors.has('last_name')}"
                       v-model="updateParticipantForm.last_name"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('last_name')">
                    <strong>{{ updateParticipantForm.errors.get('last_name') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="suffix">{{ translate('invoice.suffix') }}</label>
                <input id="suffix" type="text" name="suffix"
                       v-model="updateParticipantForm.suffix"
                       :class="{'is-invalid': updateParticipantForm.errors.has('suffix')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('suffix')">
                    <strong>{{ updateParticipantForm.errors.get('suffix') }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3>{{ translate('invoice.current_address') }}</h3>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label for="email">{{ translate('invoice.email') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="email" type="email" name="email"
                       :class="{'is-invalid': updateParticipantForm.errors.has('email')}"
                       v-model="updateParticipantForm.email"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('email')">
                    <strong>{{ updateParticipantForm.errors.get('email') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="phone_number">{{ translate('invoice.phone_number') }}</label>
                <input id="phone_number" type="text" name="phone_number"
                       v-model="updateParticipantForm.phone_number"
                       :class="{'is-invalid': updateParticipantForm.errors.has('phone_number')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('phone_number')">
                    <strong>{{ updateParticipantForm.errors.get('phone_number') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="mobile_phone_number">
                  {{ translate('invoice.mobile_phone_number') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="mobile_phone_number" type="text" name="mobile_phone_number"
                       v-model="updateParticipantForm.mobile_phone_number"
                       :class="{'is-invalid': updateParticipantForm.errors.has('mobile_phone_number')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('mobile_phone_number')">
                    <strong>{{ updateParticipantForm.errors.get('mobile_phone_number') }}</strong>
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="address">{{ translate('invoice.address') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="address" type="text" name="address"
                       v-model="updateParticipantForm.address"
                       :class="{'is-invalid': updateParticipantForm.errors.has('address')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('address')">
                    <strong>{{ updateParticipantForm.errors.get('address') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="city">{{ translate('invoice.city') }} <sup
                  class="sup-star">*</sup></label>
                <input id="city" type="text" name="city" v-model="updateParticipantForm.city"
                       :class="{'is-invalid': updateParticipantForm.errors.has('city')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('city')">
                    <strong>{{ updateParticipantForm.errors.get('city') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="country">
                  {{ translate('invoice.country') }} <sup class="sup-star">*</sup>
                </label>

                <multiselect v-model="country"
                             id="country"
                             name="country"
                             :class="{'is-invalid': updateParticipantForm.errors.has('country')}"
                             deselect-label="Required"
                             :select-label="countrySelectLabel"
                             open-direction="bottom"
                             :label="countryLabel"
                             track-by="id"
                             :options="nations"
                             :searchable="true"
                             :allow-empty="false">
                </multiselect>
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('country')">
                    <strong>{{ updateParticipantForm.errors.get('country') }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="zip">{{ translate('invoice.zip') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="zip" type="text" name="zip" v-model="updateParticipantForm.zip"
                       :class="{'is-invalid': updateParticipantForm.errors.has('zip')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('zip')">
                    <strong>{{ updateParticipantForm.errors.get('zip') }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p>
            {{ translate('invoice.bought_already') }}
            <br>
            {{ translate('invoice.share_info') }}
          </p>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="address">
                  {{ translate('invoice.birth_date') }}
                  <sup class="sup-star">*</sup>
                </label>
                <datepicker
                  v-model="birthDate"
                  name="birth_date"
                  id="birth_date"
                  class="read-only-white"
                  initial-view="year"
                  :language="language"
                  :input-class="{'is-invalid': updateParticipantForm.errors.has('birth_date')}"
                  :bootstrap-styling="true">
                </datepicker>
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('birth_date')">
                    <strong>{{ updateParticipantForm.errors.get('birth_date') }}</strong>
                </span>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="birth_place">
                  {{ translate('invoice.birth_place') }}
                  <sup class="sup-star">*</sup>
                </label>
                <input id="birth_place" type="text" name="birth_place"
                       v-model="updateParticipantForm.birth_place"
                       :class="{'is-invalid': updateParticipantForm.errors.has('birth_place')}"
                       class="form-control">
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('birth_place')">
                    <strong>{{ updateParticipantForm.errors.get('birth_place') }}</strong>
                </span>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label for="birth_nation">
                  {{ translate('invoice.birth_nation') }}
                  <sup class="sup-star">*</sup>
                </label>

                <multiselect v-model="nation"
                             id="birth_nation"
                             name="birth_nation"
                             :class="{'is-invalid': updateParticipantForm.errors.has('birth_nation')}"
                             deselect-label="Required"
                             :select-label="countrySelectLabel"
                             open-direction="bottom"
                             :label="countryLabel"
                             track-by="id"
                             :options="nations"
                             :searchable="true"
                             :allow-empty="false">
                </multiselect>
                <span class="invalid-feedback" role="alert"
                      v-if="updateParticipantForm.errors.has('birth_nation')">
                    <strong>{{ updateParticipantForm.errors.get('birth_nation') }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p>
            {{ translate('invoice.terms') }} <a href="https://www.osd.at/datenschutz/" target="_blank">
            {{ translate('invoice.data_protection') }}</a>.
          </p>
        </div>
      </section>

      <button class="btn btn-primary float-right"
              :disabled="updateParticipantForm.busy"
              type="submit"
              @click.prevent="updateParticipant">
        {{ translate('invoice.save') }}
      </button>

      <a class="btn btn-primary" :href="'/test-attempts/' + participant.test_attempt_id">
        <i class="fa fa-angle-left"></i> Cancel
      </a>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import {en, de} from 'vuejs-datepicker/dist/locale';

export default {
  props: ['participant', 'nations'],
  mixins: [require('../../../../resources/js/mixin')],

  components: {
    Multiselect,
    Datepicker,
  },

  /**
   * The component's data.
   */
  data () {
    return {
      nation: null,
      country: null,
      birthDate: null,

      updateParticipantForm: new AppForm({
        gender: null,
        prefix: null,
        first_name: null,
        last_name: null,
        suffix: null,
        email: null,
        phone_number: null,
        mobile_phone_number: null,
        address: null,
        zip: null,
        city: null,
        country: null,
        birth_date: null,
        birth_place: null,
        birth_nation: null,
      }),
    };
  },

  mounted () {
    let self = this;

    this.updateParticipantForm.gender = this.participant.gender;
    this.updateParticipantForm.prefix = this.participant.prefix;
    this.updateParticipantForm.first_name = this.participant.first_name;
    this.updateParticipantForm.last_name = this.participant.last_name;
    this.updateParticipantForm.suffix = this.participant.suffix;
    this.updateParticipantForm.email = this.participant.email;
    this.updateParticipantForm.phone_number = this.participant.phone_number;
    this.updateParticipantForm.mobile_phone_number = this.participant.mobile_phone_number;
    this.updateParticipantForm.address = this.participant.address;
    this.updateParticipantForm.zip = this.participant.zip;
    this.updateParticipantForm.city = this.participant.city;
    this.updateParticipantForm.country = this.participant.country;
    this.updateParticipantForm.birth_date = this.participant.birth_date;
    this.updateParticipantForm.birth_place = this.participant.birth_place;
    this.updateParticipantForm.birth_nation = this.participant.birth_nation;

    this.country = this.participant.country ? this.nations.find(nation => nation.id === self.participant.country) : null;
    this.nation = this.participant.birth_nation ? this.nations.find(nation => nation.id === self.participant.birth_nation) : null;
    this.birthDate = this.participant.birth_date ? new Date(this.participant.birth_date) : null;
  },

  computed: {
    countrySelectLabel () {
      return this.translate('invoice.select_country');
    },

    countryLabel () {
      return 'name_' + App.locale;
    },

    language () {
      if (this.app.locale === 'en') {
        return en;
      }

      return de;
    },
  },

  methods: {
    updateParticipant () {
      let self = this;

      if (this.nation) {
        this.updateParticipantForm.birth_nation = this.nation.id;
      }

      if (this.country) {
        this.updateParticipantForm.country = this.country.id;
      }

      if (this.birthDate) {
        this.updateParticipantForm.birth_date = moment(this.birthDate).format('YYYY-MM-DD');
      }

      App.put('/api/participants/' + this.participant.id, this.updateParticipantForm)
        .then(() => {
          window.location.href = '/test-attempts/' + self.participant.test_attempt_id;
        });
    },
  }
};
</script>
